import { render, staticRenderFns } from "./DeliveryOptions.vue?vue&type=template&id=3c488c9a&scoped=true&"
import script from "./DeliveryOptions.vue?vue&type=script&lang=js&"
export * from "./DeliveryOptions.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOptions.vue?vue&type=style&index=0&id=3c488c9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c488c9a",
  null
  
)

export default component.exports